import { ReactNode }                                from 'react';
import { XIcon }                                    from '@heroicons/react/outline';
import { Popover }                                  from '@mui/material';
import { CloseButton, PopperHeader, PopperWrapper } from '@styles/Shared/StyledAppPopover';
import { TAnchor }                                  from '../hooks/useAnchor';

export interface IAppPopoverProps {
  title?: string;
  anchor: TAnchor;
  children?: ReactNode;
  toggleAnchor(event?: React.MouseEvent<TAnchor> | null): void;
  width?: string;
}

export const AppPopover = ({ title, anchor, toggleAnchor, children, width }: IAppPopoverProps) =>  (
  <Popover
    open={!!anchor}
    id="app-popover"
    anchorEl={anchor}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    onClose={() => toggleAnchor(null)}
  >
    <PopperWrapper width={width}>
      <PopperHeader>{title}</PopperHeader>

      <CloseButton onClick={toggleAnchor}>
        <XIcon width={16} />
      </CloseButton>

      {children}
    </PopperWrapper>
  </Popover>
);
